import list from 'src/modules/flowStep/list/flowStepListReducers';
import form from 'src/modules/flowStep/form/flowStepFormReducers';
import view from 'src/modules/flowStep/view/flowStepViewReducers';
import destroy from 'src/modules/flowStep/destroy/flowStepDestroyReducers';
import importerReducer from 'src/modules/flowStep/importer/flowStepImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
